import { memo, useState } from 'react';
import ReactGA from 'react-ga4';

import { ProductInterface } from 'graphql/generated/magentoApi';
import { useCartContext } from 'CartContext';
import { Card } from 'primereact/card';
import { Link } from 'react-router-dom';
import Stars from 'components/Stars';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';
import './ProductCard.scss';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

interface ProductCardProps {
  product: ProductInterface;
  onClickAddBtn: (sku: string) => void;
  loading: boolean;
}

export default memo((props: ProductCardProps) => {
  const { product, onClickAddBtn, loading } = props;
  const { getProductWebsiteUrl } = useCartContext();
  const { t } = useTranslation();
  const [websiteUrl, setWebsiteUrl] = useState(() =>
    getProductWebsiteUrl(product),
  );

  if (!product?.sku) return <></>;

  const onClickVisitWebsiteBtn = (url: string) => {
    window.open(url, '_blank');

    ReactGA.event({
      category: 'external_link',
      action: 'Visit Website - Product Card',
      label: `Visited ${url}`,
    });
    setWebsiteUrl(() => getProductWebsiteUrl(product));
  };

  return (
    <div className="col-12 md:col-6 lg:col-4 product-card-col">
      <Card
        header={
          <Link
            to={`/product/${product.sku}`}
            style={{ background: `url(${product.image.url})` }}
            className="product-card-image"
            aria-label={product.name}
          />
        }
        className="border-0 md:border-1 h-full flex flex-row md:flex-column justify-content-between mx-auto product-card-list-item mb-4 md:mb-0 align-items-center md:align-items-stretch p-2 md:p-0 w-11 md:w-12 mx-auto md:mx-0"
      >
        {/* align-items-center lg:align-items-start p-2 lg:p-0 w-11 lg:w-12 mx-auto lg:mx-0 */}
        <div className="mb-1 md:mb-3">
          <p className="uppercase m-0 font-bold line-height-2">
            {product.name}
          </p>
          {websiteUrl ? (
            <Button
              className="capetilize text-xs text-left mt-0 mb-1 mx-0 p-0 border-noround learn-more-button line-height-0"
              label={product.vendor_company}
              onClick={() => onClickVisitWebsiteBtn(websiteUrl)}
              id={`product-view-website-${product.sku}`}
            />
          ) : (
            <p className="capetilize mt-0 mb-1 text-xs line-height-0">
              {product.vendor_company}
            </p>
          )}

          <div className="flex justify-content-between">
            <span className="ml-1 font-semibold text-lg">
              {product.price_range.maximum_price.final_price.value
                ? `${formatter.format(
                    product.price_range.maximum_price.final_price.value,
                  )}`
                : 'Free'}
            </span>
            {!!product.rating_summary && (
              <Stars rating={(product.rating_summary * 5) / 100} />
            )}
          </div>
        </div>
        <div className="flex flex-column align-items-start">
          <Button
            className="uppercase font-bold text-xs border-noround c-button-primary my-0 mb-2"
            label={t('add_to_cart')}
            onClick={() => onClickAddBtn(product.sku)}
            loading={loading}
            id={`product-add-to-cart-${product.sku}`}
          />
          {/* {websiteUrl && (
            <Button
              className="uppercase text-xs mt-0 text-left md:mt-2 ml-0 border-noround learn-more-button pl-0"
              label={t('visit_website')}
              onClick={() => onClickVisitWebsiteBtn(websiteUrl)}
              id={`product-view-website-${product.sku}`}
            />
          )} */}
        </div>
      </Card>
    </div>
  );
});
